module.exports = __webpack_public_path__ + "static/media/pulangBato.c9dc56a4.jpg";